<script>
  export default {
    name: 'dashboard-my-apps'
  }
</script>

<template>
  <section class="mb-4">
    <router-link to="/apps" class="text-muted small float-right mt-1">See all &gt;</router-link>
    <h5>My Apps</h5>

    <div class="my-apps card">
      <b-list-group>
        <b-list-group-item>
          <img src="/img/apps/cnn_icon.png" alt="" class="app-icon"> CNN
        </b-list-group-item>
        <b-list-group-item>
          <img src="/img/apps/instagram_icon.png" alt="" class="app-icon"> Instagram
        </b-list-group-item>
        <b-list-group-item>
          <img src="/img/apps/espn_icon.png" alt="" class="app-icon"> ESPN
        </b-list-group-item>
        <b-list-group-item>
          <img src="/img/apps/photos_icon.png" alt="" class="app-icon"> Dynamic Photos
        </b-list-group-item>
      </b-list-group>
    </div>
  </section>
</template>

<style src="./DashboardMyApps.scss" lang="scss" scoped></style>
